<h1 mat-dialog-title i18n="Select Teacher|Teacher selection title@@select-teacher-selection-title">Teacher Selection</h1>

<div mat-dialog-content #dialogContent class="full-width details-content">
  <p i18n="Select Teacher|Select Teacher details@@select-teacher-details">
    Select one of the registered teachers from a school. Please check again later and choose if the teacher is not yet registered.
  </p>
  <p i18n="Select Teacher|Select Teacher change details@@select-teacher-change-details">
    A teacher can be changed at any time before the contest ends.
  </p>
  <p class="select-holder">
    <item-select class="full-width"
                 [roles]="roles"
                 label="Select Teacher"
                 i18n-label="Select Teacher|Select Teacher title@@select-teacher-title"
                 noItemsLabel="No teachers have registered for your school yet"
                 i18n-noItemsLabel="Select Teacher|No teachers in school message@@select-teacher-no-teachers-message"
                 [disabled]="inProgress"
                 [compareWith]="compareTeachers"
                 [displayWith]="displayTeacher"
                 [loadWith]="loadTeachers"
                 [selectedItem]="teacher"
                 (selected)="handleTeacherSelected($event)"></item-select>
  </p>
</div>

<div mat-dialog-actions>
  <app-button [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Close"
              i18n-label="General|Close action label@@general-close-action-label"></app-button>

  <span class="btn-spacer"></span>

  <app-button label="Select"
              i18n-label="General|Select action label@@general-select-action-label"
              [disabled]="inProgress || !proceedAllowed()"
              (clicked)="proceed()"></app-button>
</div>
